import React, { PureComponent } from 'react';
import { connect } from 'unistore/react';
import styled from 'styled-components';
import { drag, select, event } from 'd3';

import { weightedIncomeSelector } from '~/state/Selectors';
import Actions from '~/state/Actions';
import { nf } from '~/Utils';
import { media } from '~/styles/Utils';

const IncomeLineWrapper = styled.g``;

const Line = styled.line`
  stroke: ${p => p.theme.colors.blue};
  stroke-width: 2;
  shape-rendering: crispEdges;
  pointer-events: none;
`;

const Label = styled.text`
  user-select: none;
  pointer-events: none;
  font-size: 14px;
  text-anchor: middle;
  font-weight: bold;
`;

const Handle = styled.rect`
  stroke-width: 2px;
  stroke: ${p => p.theme.colors.blue};
  fill: white;
  cursor: move;

  ${media.m`
    &:hover {
      fill: ${p => p.theme.colors.blue};
    }
  `}
`;

const HandleWrapper = styled.g`
  ${media.m`
    &:hover {
      fill: white;
    }
  `}
`;

const Triangle = styled.path`
  fill: ${p => p.theme.colors.blue};
`;

const TriangleUp = styled(Triangle).attrs({
  d: 'M 5,0 L 0,6 L 10,6 z'
})``;

const TriangleDown = styled(Triangle).attrs({
  d: 'M 0,0 L 10,0 L 5,6 z'
})``;

function clamp(value, min, max) {
  return Math.min(Math.max(value, min), max);
}

class IncomeLine extends PureComponent {
  container = React.createRef();

  componentDidMount() {
    const dragBehaviour = drag()
      .on('drag', this.handleDrag.bind(this));

    select(this.container.current)
      .call(dragBehaviour);
  }

  handleDrag() {
    const {
      yScale,
      householdMembersAbove14,
      householdMembersBelow14,
      setHouseholdIncome
    } = this.props;

    const { y } = event;
    const weightedIncome = clamp(yScale.invert(y), 0, 7000);
    const householdIncome = Math.round(
      (1 + (householdMembersAbove14 - 1) * 0.5 + householdMembersBelow14 * 0.3) * weightedIncome
    );

    setHouseholdIncome(householdIncome);
  }

  render() {
    const { weightedIncome, yScale, width } = this.props;
    const yPos = yScale(weightedIncome);
    const weightedIncomeLabel = weightedIncome >= 7000 ? '> 7.000' : nf(weightedIncome);

    return (
      <IncomeLineWrapper ref={this.container} transform={`translate(0, ${yPos})`}>
        <Line x1={0} y1={0} x2={width} y2={0} />
        <g transform={`translate(${width / 2 - 5}, -25)`}>
          <TriangleUp />
        </g>
        <HandleWrapper>
          <Handle rx={4} x={width / 2 - 40} y={-13} height={26} width={80} />
          <Label x={width / 2} y={5}>{weightedIncomeLabel} Euro</Label>
        </HandleWrapper>
        <g transform={`translate(${width / 2 - 5}, 18)`}>
          <TriangleDown />
        </g>
        { /* <g transform="translate(0, -4)">
          <text>
            <tspan x={0} dy="0">{nf(weightedIncome)}</tspan>
            <tspan x={0} dy="20">Einkommen</tspan>
          </text>
        </g> */ }
      </IncomeLineWrapper>
    );
  }
}

export default connect(state => ({
  weightedIncome: weightedIncomeSelector(state),
  householdMembersAbove14: state.householdMembersAbove14,
  householdMembersBelow14: state.householdMembersBelow14
}), Actions)(IncomeLine);
